<div mat-dialog-content class="custom-dialog-container">

    <div style="display:flex;flex-direction:row;">
        <h3>Nie możesz tu dodać tego mechanizmu, dodaj go do wolnej ramki.</h3>
    </div>
    <div mat-dialog-actions style="justify-content: space-around;">
        <button mat-button type="button" class="cancel-button" (click)="onNoClick()">Anuluj</button>
    </div>
</div>
